export function mergeDashboardUser(currentUser, summaryUser) {
  if (!summaryUser) {
    return currentUser;
  }

  return {
    ...(currentUser || {}),
    ...summaryUser,
    role: summaryUser.role ?? currentUser?.role,
    email: summaryUser.email ?? currentUser?.email,
  };
}
